export default function BeforeAfterTable() {
  const rows = [
    { before: 'Хаос в управлении — каждый руководитель работает по-своему', after: 'Система — единые стандарты и подходы к управлению на всех уровнях' },
    { before: 'Тотальный контроль — руководитель проверяет каждый шаг', after: 'Ответственность — сотрудники сами отвечают за результат и сроки' },
    { before: 'Давление и приказы — управление через силу и должность', after: 'Лидерство — влияние через доверие, авторитет и вовлечение' },
    { before: 'Конфликты между отделами и сотрудниками', after: 'Сотрудничество — кросс-функциональное взаимодействие и взаимопомощь' },
    { before: 'Текучка — сильные сотрудники уходят', after: 'Вовлечённость — люди растут внутри компании и остаются надолго' },
    { before: 'Перегруженный руководитель — работает за всех', after: 'Эффективный управленец — фокусируется на развитии команды и стратегии' },
    { before: 'Реактивное управление — постоянное тушение пожаров', after: 'Проактивное управление — предвидение проблем и работа на опережение' },
    { before: 'Страх ошибок — сотрудники боятся проявлять инициативу', after: 'Культура развития — ошибки становятся точками обучения и роста' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Результаты обучения руководителей: было — стало
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Системное обучение руководителей меняет не только навыки — оно трансформирует всю управленческую культуру компании
        </p>

        <div className="max-w-5xl mx-auto overflow-hidden rounded-xl border border-gray-200">
          {/* Header */}
          <div className="grid grid-cols-12 bg-gray-100">
            <div className="col-span-5 px-6 py-5 font-bold text-gray-900 text-sm flex items-center gap-2">
              <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center">
                <i className="ri-close-line text-red-600 text-lg"></i>
              </div>
              <span>Было</span>
            </div>
            <div className="col-span-2 px-4 py-5 flex items-center justify-center">
              <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-lg"></i>
              </div>
            </div>
            <div className="col-span-5 px-6 py-5 font-bold text-gray-900 text-sm flex items-center gap-2">
              <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center">
                <i className="ri-check-line text-teal-600 text-lg"></i>
              </div>
              <span>После обучения</span>
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, i) => (
            <div key={i} className={`grid grid-cols-12 border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
              <div className="col-span-5 px-6 py-4 text-sm text-gray-700 flex items-center">
                <span className="w-2 h-2 bg-red-400 rounded-full mr-3 flex-shrink-0"></span>
                {row.before}
              </div>
              <div className="col-span-2 px-4 py-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-teal-600"></i>
              </div>
              <div className="col-span-5 px-6 py-4 text-sm text-gray-900 font-medium flex items-center">
                <span className="w-2 h-2 bg-teal-500 rounded-full mr-3 flex-shrink-0"></span>
                {row.after}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}